import React from 'react';
import { Tooltip, Divider, Icon } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from '@fortawesome/free-solid-svg-icons';

export const renderTooltip = () => {
  return(
    <Tooltip title="This invoice no rebate days">
      <FontAwesomeIcon icon={faStar} style={{color: '#FB607F'}} />
    </Tooltip>
  )
}

export const renderBottom = (i) => {
  if (i.emailAttachment) {
    if (i.emailAttachment.contact && i.emailAttachment.candidate) {
      if (i.emailAttachment.contact.length > 0 && i.emailAttachment.candidate.length > 0) {
        return (
          <React.Fragment>
            <Divider />
            <div style={{ marginTop: "-15px" }}>
              <div>Contact email attachment(s)</div>
              {
                i.emailAttachment.contact.map((i, k) => (
                  <div key={k}>
                    {
                      i.icon ?
                        <img
                          style={{
                            marginTop: "-2px",
                            position: "relative",
                          }}
                          src={i.icon}
                          alt={i.name}
                        />
                        :
                        <Icon type="paper-clip" />
                    }
                    &nbsp;{i.name}
                  </div>
                ))
              }
              <br />
              <div>Candidate email attachment(s)</div>
              {
                i.emailAttachment.candidate.map((i, k) => (
                  <div key={k}>
                    {
                      i.icon ?
                        <img
                          style={{
                            marginTop: "-2px",
                            position: "relative",
                          }}
                          src={i.icon}
                          alt={i.name}
                        />
                        :
                        <Icon type="paper-clip" />
                    }
                    &nbsp;{i.name}
                  </div>
                ))
              }
            </div>
          </React.Fragment>
        )
      }

      if (i.emailAttachment.contact.length > 0 && i.emailAttachment.candidate.length === 0) {
        return (
          <React.Fragment>
            <Divider />
            <div style={{ marginTop: "-15px" }}>
              <div>Contact email attachment(s)</div>
              {
                i.emailAttachment.contact.map((i, k) => (
                  <div key={k}>
                    {
                      i.icon ?
                        <img
                          style={{
                            marginTop: "-2px",
                            position: "relative",
                          }}
                          src={i.icon}
                          alt={i.name}
                        />
                        :
                        <Icon type="paper-clip" />
                    }
                    &nbsp;{i.name}
                  </div>
                ))
              }
            </div>
          </React.Fragment>
        )
      }

      if (i.emailAttachment.contact.length === 0 && i.emailAttachment.candidate.length > 0) {
        return (
          <React.Fragment>
            <Divider />
            <div style={{ marginTop: "-15px" }}>
              <div>Candidate email attachment(s)</div>
              {
                i.emailAttachment.candidate.map((i, k) => (
                  <div key={k}>
                    {
                      i.icon ?
                        <img
                          style={{
                            marginTop: "-2px",
                            position: "relative",
                          }}
                          src={i.icon}
                          alt={i.name}
                        />
                        :
                        <Icon type="paper-clip" />
                    }
                    &nbsp;{i.name}
                  </div>
                ))
              }
            </div>
          </React.Fragment>
        )
      }

      if (i.emailAttachment.contact.length === 0 && i.emailAttachment.candidate.length === 0) {
        return null
      }
    }

    if (i.emailAttachment.contact && !i.emailAttachment.candidate) {
      if (i.emailAttachment.contact.length > 0) {
        return (
          <React.Fragment>
            <Divider />
            <div style={{ marginTop: "-15px" }}>
              {
                i.emailAttachment.contact.map((i, k) => (
                  <div key={k}>
                    {
                      i.icon ?
                        <img
                          style={{
                            marginTop: "-2px",
                            position: "relative",
                          }}
                          src={i.icon}
                          alt={i.name}
                        />
                        :
                        <Icon type="paper-clip" />
                    }
                    &nbsp;{i.name}
                  </div>
                ))
              }
            </div>
          </React.Fragment>
        )
      }
      else {
        return null
      }
    }

    if (!i.emailAttachment.contact && i.emailAttachment.candidate) {
      if (i.emailAttachment.candidate.length > 0) {
        return (
          <React.Fragment>
            <Divider />
            <div style={{ marginTop: "-15px" }}>
              {
                i.emailAttachment.candidate.map((i, k) => (
                  <div key={k}>
                    {
                      i.icon ?
                        <img
                          style={{
                            marginTop: "-2px",
                            position: "relative",
                          }}
                          src={i.icon}
                          alt={i.name}
                        />
                        :
                        <Icon type="paper-clip" />
                    }
                    &nbsp;{i.name}
                  </div>
                ))
              }
            </div>
          </React.Fragment>
        )
      }
      else {
        return null
      }
    }
  }
  else {
    return null
  }
}